import { FixedParamsTable } from '../../Tables/FixedParamsTable/FixedParamsTable';
import { PHChart } from '../../Charts/PHChart/PHChart';
import { CHEMICAL_INDEX_CODES } from '../../../constants/parameters.constants';
import type { FixedParam } from '../../../types/parameters.types';

interface ChemicalIndexesTabProps {
	fixedParams: FixedParam[];
	isLoading: boolean;
	onChange: (params: FixedParam[]) => void;
}

export const ChemicalIndexesTab = ({ fixedParams, isLoading, onChange }: ChemicalIndexesTabProps) => {
	const subset = fixedParams.filter(
		(p) => CHEMICAL_INDEX_CODES.includes(p.code) && p.code !== 'pHagua'
	);
	const phParam = fixedParams.find((p) => p.code === 'pHagua') ?? null;

	const handleChange = (updatedSubset: FixedParam[]) => {
		const merged = fixedParams.map((p) => updatedSubset.find((u) => u.code === p.code) ?? p);
		onChange(merged);
	};

	return (
		<>
			<FixedParamsTable params={subset} isLoading={isLoading} onChange={handleChange} />
			{phParam && !isLoading && <PHChart param={phParam} />}
		</>
	);
};
